import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
// takes a simple array(sourceArray) and converts it into a multidimensional array
// creates an empty array(result), iterates over sourceArray and pushes array slices into result
// length of slices (the number of items per column) based on "size" argument.
// See FilterChild.tsx for an explanation of how we get the number
export var arrayConverter = function (sourceArray, size) {
    var result = [];
    // i is current index of array that we start with
    // increment based on how many we are pushing into a child array
    // eg our columns have 2 items. Start at 0, increment to "0 + 2" index after we do the action
    for (var i = 0; i < sourceArray.length; i += size) {
        // push into result a "sub-array" slice that starts with current index
        // and ends with entry before current index + size
        // eg at first iteration, make a slice of source that includes sourceArray[0]
        // and up to, but not including, sourceArray[2] (so just [0] and [1] in our example)
        // next iteration, push a slice that starts at sourceArray[2] and up to sourceArray[4]
        // last iteration, we may end up with an index that's too large to exist, and that's fine.
        result.push(sourceArray.slice(i, i + size));
    }
    return result;
};
export var filterSpace = null;
// renders children based on arguments. The filter section has higher flex value
// selectors has lower flex value and a divider on its left
export var renderChildren = function (elements, flex, showDivider) { return (React.createElement(Box, { display: "flex", flex: flex, justifyContent: "space-around" },
    showDivider && React.createElement(Divider, { orientation: "vertical" }),
    elements.map(function (entry, idx) {
        var keyGen = "filterEntry".concat(idx);
        var lastOfType = elements.length - 1 === idx;
        return (React.createElement(Box, { key: keyGen, display: "flex", flexDirection: "column", flex: 1, paddingLeft: 4, paddingRight: lastOfType ? 4 : 0 }, entry.map(function (itm, index) {
            var key2 = "childentry".concat(index);
            if (index === entry.length - 1) {
                return React.createElement("div", { key: key2 }, itm);
            }
            return (React.createElement(Box, { paddingBottom: 2, key: key2 }, itm));
        })));
    }))); };
//# sourceMappingURL=helpers.js.map